import {
    axiosServer
} from '@/api/judge';
import {
    urls
} from '@/api/urls';
import {
    formatDate
} from '@/utils/date';

export const SVPConfigKey = {
    SvApply: 'sv_apply', //搭载申请时间
    CsApply: 'cs_apply', //首席申请时间
    CsApplyQuest: 'cs_apply_quest', //首席问卷填写时间
    CsApplyExplain: 'cs_apply_explain', //首席问卷填写时间
    ScientificOrientationExplain: 'so_explain', //科学导向
    CSImportant: 'cs_important', //重大首席
    SvpChiefTraining: 'SvpChiefTrainingVoyageConfig',
    ApplyYears: 'applyYearsOptions'
};

export function requestSoExplain() {
    return requestConfig(SVPConfigKey.ScientificOrientationExplain).then(resp => {
        return parseConfig(resp);
    });
}

export function requestImpotantCsExplain() {
    return requestConfig(SVPConfigKey.CSImportant).then(resp => {
        return parseConfig(resp);
    });
}

export function requestSvApply() {
    return requestConfig(SVPConfigKey.SvApply).then(resp => {
        return parseConfig(resp);
    });
}

export function requestCsApply() {
    return requestConfig(SVPConfigKey.CsApply).then(resp => {
        return parseCs(resp);
    });
}

export function requestCsApplyExplain() {
    return requestConfig(SVPConfigKey.CsApplyExplain).then(resp => {
        return Promise.resolve(resp.cfg.cfgValue);
    });
}

export function requestCsApplyQuest() {
    return requestConfig(SVPConfigKey.CsApplyQuest).then(resp => {
        return parseConfig(resp);
    });
}

export function requestSvpChiefTraining() {
    return requestConfig(SVPConfigKey.SvpChiefTraining).then(resp => {
        return parseConfig(resp);
    });
}

export function requestApplyYears() {
    return requestConfig(SVPConfigKey.ApplyYears).then(resp => {
        return Promise.resolve(JSON.parse(resp.cfg.cfgValue));
    });
}

function parseCs(resp) {
    let cfgValue = resp.cfg.cfgValue;
    let cfgValueJson = JSON.parse(cfgValue);
    let content1 = cfgValueJson.content1
        .replace('[start]', convertTime(cfgValueJson.start))
        .replace('[end]', convertTime(cfgValueJson.end));

    let content2 = cfgValueJson.content2
        .replace('[start]', convertTime(cfgValueJson.start))
        .replace('[end]', convertTime(cfgValueJson.end));

    let desc1 = cfgValueJson.description1
        .replace('[start]', convertTime(cfgValueJson.start))
        .replace('[end]', convertTime(cfgValueJson.end));

    let desc2 = cfgValueJson.description2
        .replace('[start]', convertTime(cfgValueJson.start))
        .replace('[end]', convertTime(cfgValueJson.end));

    let expired = !(resp.time - new Date(convertDate(cfgValueJson.end)).getTime() < 0 &&
        resp.time - new Date(convertDate(cfgValueJson.start)).getTime() > 0);
    return Promise.resolve({
        content1: content1,
        content2: content2,
        desc1: desc1,
        desc2: desc2,
        expired: expired,
        description: cfgValueJson.description
    });
}

function parseConfig(resp) {
    let cfgValue = resp.cfg.cfgValue;
    let cfgValueJson = JSON.parse(cfgValue);
    let content = cfgValueJson.content
        .replace('[start]', convertTime(cfgValueJson.start))
        .replace('[end]', convertTime(cfgValueJson.end));

    // console.log("server time " + resp.time)
    // console.log("end time " + new Date(convertDate(cfgValueJson.end)).getTime())
    // console.log("start time " + new Date(convertDate(cfgValueJson.start)).getTime())

    let expired = !(resp.time - new Date(convertDate(cfgValueJson.end)).getTime() < 0 &&
        resp.time - new Date(convertDate(cfgValueJson.start)).getTime() > 0);
    return Promise.resolve({
        content: content,
        expired: expired,
        description: cfgValueJson.description
    });
}

//兼容ie safra 浏览器
function convertDate(date) {
    return date.replace(/-/g, '/')
}

function convertTime(time) {
    let date = new Date(time);
    return formatDate(date, 'yyyy-MM-dd hh:mm');
}

export function requestIndexConfig() {
    return axiosServer({
        url: urls.SvpConfig + '/index',
        type: 'get'
    })
        .then(resp => {
            if (resp.data.code == 0) {
                return parseConfig({
                    cfg: resp.data.entity,
                    time: resp.data.time
                });
            } else {
                return Promise.reject('未知');
            }
        })
        .catch(e => {
            return Promise.reject(e);
        });
}

function requestConfig(cfgKey) {
    let reqBody = {
        page: 1,
        pageSize: 10,
        cfgKey: cfgKey
    };
    return axiosServer({
        url: urls.SvpConfig,
        type: 'get',
        params: reqBody
    })
        .then(resp => {
            if (resp.data.code == 0) {
                return Promise.resolve({
                    cfg: resp.data.page.list[0],
                    time: resp.data.time
                });
            } else {
                return Promise.reject(resp.data);
            }
        })
        .catch(e => {
            return Promise.reject(e);
        });
}